var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#78a3cd",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5e03d",
    d: "M0 112.5h900v375H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c20002",
    d: "M0 150h900v300H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M184.275 258.009H719.97v8.571H184.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8d8d8",
    strokeWidth: 1.5,
    d: "M683.204 262.2h.18v4h-.18zm11.997 0h.18v4h-.18zm-3 0h.18v4h-.18zm-3 0h.18v4h-.18zm-3 0h.18v4h-.18z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M152.372 284.735h535.695v8.57H152.371z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    strokeWidth: 1.5,
    d: "M681.002 276.155v25.713L731 289.01zM713 248.92v25.712l49.999-12.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "none",
    d: "m361.21 242.676 9.417-36.322 6.728 43.72-1.346-51.794 16.815 53.813-12.106-51.121 20.851 49.102-10.089-51.794"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.62,
    d: "M89.718 310h728.55v12.857H89.718z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.512,
    d: "M674.209 300.829c-30.076 67.741-109.936 127.737-224.224 127.737-100.002 0-171.42-85.712-214.29-128.566 42.857-42.861 114.282-128.574 214.29-128.574 114.282 0 188.08 56.789 224.115 129.274h.3-.1l-.1.1z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M435.03 216.15c11.402 12.823 1.881 17.994 13.95 18.835 12.727.935-4.578 16.242 6.128 16.681 7.485.327 2.616 26.862 9.82 36.729 7.34 10.286 7.434 3.687 7.563 11.117.127 7.686-11.232 6.911-11.584 30.585-.59 13.644-12.929 14.517-13.711 23.297-.972 8.257 11.409 13.565 10.965 20.957-.456 7.37-4.941 5.543-6.483 13.948-.79 7.55 23.781 15.755 27.759 37.588-7.38 2.413-13.581 2.667-29.451 2.679-99.985.072-171.42-35.944-224.286-128.566 54.886-96.68 124.293-128.582 224.301-128.582 0 0-29.683 27.123-14.956 44.723z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b3f2a",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M710.77 307.167c1.173-4.21 37.797-6.48 42.377-1.344 3.168 3.554 3.261 18.747-1.008 22.533-6.135 5.442-40.512 4.026-41.367.338-1.1-4.748-.995-17.968-.002-21.527Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 10.3905,
    d: "M292.9 288.566V254.28m28.77 0v34.286m28.793-34.286v34.286m-57.563 57.15V311.43m28.77 0v34.286m28.793-34.286v34.286m28.774-57.15V254.28m28.77 0v34.286M436.8 254.28v34.286m-57.563 57.15V311.43m28.77 0v34.286M436.8 311.43v34.286"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 10.39,
    d: "M466.001 288.566V254.28m28.772 0v34.286m28.792-34.286v34.286m-57.564 57.15V311.43m28.772 0v34.286m28.792-34.286v34.286m28.773-57.15V254.28m28.77 0v34.286M609.9 254.28v34.286m-57.563 57.15V311.43m28.77 0v34.286M609.9 311.43v34.286"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#222"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.282,
    d: "M767.025 311.311c-6.492 11.244 4.982-3.74 32.978 15.084 5.188 3.497 9.721 12.734 9.721 19.139-1.317-.881-2.295-2.841-3.745-4.115-2.031 2.035 1.939 11.366 2.52 15.775-4.377-2.449-3.956-3.609-5.41-6.619.29 3.639-2.096 10.297-.355 14.157-3.45-.986-2.548-5.78-4.349-6.338 1.225 4.368-.395 10.467.213 15.378-2.015-1.995-6.181-6.921-7.118-7.727-.157 2.338-2.532 10.502-2.616 12.713-1.71-1.033-4.193-5.335-4.478-6.42-2.126 2.671-11.026 7.829-11.51 10.838-5.822-5.142-16.699-4.883-18.64-11.529-1.716 3.772-4.2 5.046-9.11 7.8-1.939-10.533-9.194-22.372-5.314-31.401-2.75 1.63-5.013 3.261-7.761 5.267 2.604-15.255 15.88-33.143 34.979-42.002z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.6,
    d: "M121.174 322.141c-.363-3.274.338-3.666-1.677-6.135 2.933 1.227 3.044 4.488 6.61 2.174 1.309-.678 1.88-.7.289-4.337 3.718.173 15.894 4.348 17.844 4.444 5.12.236 14.466-5.378 20.953 1.525 6.227 6.294 4.148 12.826 4.148 21.543-2.502-1.199-1.296-1.79-3.951-4.907 1.99 7.619-.106 21.356-.106 29.436-1.022-1.948-.872-1.103-1.871-3.12-2.655 7.375-3.146.149-3.146 8.866-.958-3.418-3.397-4.714-4.463-6.512-2.58 5.6-13.836 6.349-7.166 11.993-6.02-3.53-12.023-4.504-14.753-7.679-1.177.759-6.82 4.213-7.914 6.182-10.585-4.87-4.109-1.249-12.402-8.266-1.435 2.942-.781 2.516-2.332 7.304-1.679-6.651-2.138-10.877-4.026-15.767-1.629 2.71-1.484 1.671-4.442 5.768-1.224-8.102-3.216-10.014-2.428-15.375-3.144 2.218-1.086 1.32-4.229 4.05 2.978-20.76 15.837-36.101 25.065-31.188z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#999",
    strokeWidth: 1.239,
    d: "M380.7 194.25c-5.937 11.482 10.395-3.819 35.997 15.404 4.745 3.571 11.546 17.68 11.546 24.22-5.451-1.16-15.104-6.54-15.104-6.54s12.673 7.31 12.673 20.39c-4.002-2.502-7.349-3.472-8.68-6.544 0 4.234 3.56 9.623 3.56 16.163-2.435-1.956-6.384-4.365-9.125-5.862 3.776 6.54-9.571 5.773-4.238 10.008-9.327-1.349-14.834-1.926-18.61-8.466-2.001 1.348-4.909 3.466-4.987 5.723.294.245-10.162-4.03-8.83-8.256-1.944 2.727-6.253 4.226-6.697 7.3-5.323-5.25-7.512-5.791-9.288-12.579-2.365 3.073-2.514 3.073-4.88 6.147-1.774-10.757-1.774-10.373 1.775-19.592-2.514 1.665-4.584 3.33-7.098 5.38 2.38-15.578 14.523-33.845 31.988-42.892z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    stroke: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.401 250.158h2v47.141h-2z",
    transform: "rotate(19.107 473.412 454.536)skewX(4.007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.46 256.853h2v48.719h-2z",
    transform: "rotate(-42.852 243.022 44.761)skewX(-13.211)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.363 282.652h2v53.438h-2z",
    transform: "rotate(-10.173 -138.52 -376.34)skewX(-3.892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.024 250.314h2v47.48h-2z",
    transform: "rotate(-50.003 269.178 69.926)skewX(-13.792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.965 272.571h2v51.532h-2z",
    transform: "rotate(-27.288 168.351 -40.434)skewX(-9.73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.096 200.298h2v53.764h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.024 179.445h2v34.037h-2z",
    transform: "rotate(-75.003 339.693 107.407)skewX(-13.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.811 200.42 1.98.279-6.958 49.513-1.98-.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.024 204.799h2v38.847h-2z",
    transform: "rotate(-69.003 322.19 107.248)skewX(-13.792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.817 242.26h1.849v45.652h-1.849z",
    transform: "rotate(45.189 116.055 99.569)skewX(5.927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.221 243.392h1.89v46.165h-1.89z",
    transform: "rotate(-19.559 406.303 483.95)skewX(-16.366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.622 275.036h1.84v51.999h-1.84z",
    transform: "rotate(14.215 17.612 -116.854)skewX(-4.865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.542 201.58h1.904v38.236h-1.904z",
    transform: "rotate(-26.677 452.626 437.176)skewX(-17.081)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.789 262.279h1.861v49.587h-1.861z",
    transform: "rotate(-3.705 1076.955 1475.75)skewX(-12.106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.188 315.027 1.665.776-22.153 47.508-1.665-.776z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.355 165.444h1.943v31.381h-1.943z",
    transform: "rotate(-50.836 363.73 352.082)skewX(-15.761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.269 181.392h1.839v48.689h-1.839z",
    transform: "rotate(33.485 15.967 -104.748)skewX(.943)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.333 189.481h1.935v35.942h-1.935z",
    transform: "rotate(-45.122 356.765 370.83)skewX(-16.529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.38 264.949h1.927v49.927h-1.927z",
    transform: "rotate(21.426 381.091 1488.767)skewX(8.027)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.208 259.652h2.017v49.249h-2.017z",
    transform: "rotate(-46.42 561.105 -362.462)skewX(-19.749)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.02 302.535h1.906v57.197h-1.906z",
    transform: "rotate(-11.49 583.91 -2276.736)skewX(-5.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.541 222.082h2.05v42.124h-2.05z",
    transform: "rotate(-53.474 603.598 -268.82)skewX(-20.597)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.244 284.681h1.954v53.823h-1.954z",
    transform: "rotate(-30.301 554.935 -721.003)skewX(-14.694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.404 318.685h1.899v55h-1.899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.286 171.577h2.134v32.544h-2.134z",
    transform: "rotate(-76.694 614.727 -73.434)skewX(-18.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.157 199.711h1.903v53.607h-1.903z",
    transform: "rotate(9.045 -194.77 2762.993)skewX(1.973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.062 197.18h2.12v37.402h-2.12z",
    transform: "rotate(-71.283 601.859 -102.072)skewX(-19.485)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.d201c3699a264977cbbc7ec5b799ebca.svg";
export { ForwardRef as ReactComponent };